import React from 'react';
import { IcParty } from 'components/common/icons/EmojiIcons';
import styles from './TreatCelebrationBanner.module.css';

/** 클래스 이름을 해시된 이름으로 바꿉니다. 모르는 이름은 그대로 둡니다.
 *  이름을 바꾸지 않고 스코프만 씌우려고 둔 얇은 헬퍼입니다. */
const cls = (names?: string): string =>
    (names || '').split(' ').filter(Boolean)
        .map((n) => (styles as Record<string, string>)[n] || n).join(' ');

/**
 * "OOO님이 쏘셨어요" 축하 배너 — Home / MeetingDetail / CostInput 공용
 * 폭죽 SVG + 그라데이션 배경
 */

interface TreatItem {
    meetingName?: string;
    paidByNickname: string;
    storeName?: string;
    round?: number; // 오늘 모임 N차
    onClick?: () => void;
}

interface Props {
    items: TreatItem[];
    /** 단일 배너 모드 (가장 최근 1개만 노출) */
    compact?: boolean;
}

// 폭죽 SVG
const FireworksIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg viewBox="0 0 48 48" width="48" height="48" fill="none" {...props}>
        {/* 중앙 폭죽 */}
        <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M24 24 L24 10" />
            <path d="M24 24 L36 12" />
            <path d="M24 24 L38 24" />
            <path d="M24 24 L36 36" />
            <path d="M24 24 L24 38" />
            <path d="M24 24 L12 36" />
            <path d="M24 24 L10 24" />
            <path d="M24 24 L12 12" />
        </g>
        {/* 끝점 별 모양 */}
        <g fill="currentColor">
            <circle cx="24" cy="8" r="2" />
            <circle cx="38" cy="10" r="1.6" />
            <circle cx="40" cy="24" r="2" />
            <circle cx="38" cy="38" r="1.6" />
            <circle cx="24" cy="40" r="2" />
            <circle cx="10" cy="38" r="1.6" />
            <circle cx="8" cy="24" r="2" />
            <circle cx="10" cy="10" r="1.6" />
        </g>
        {/* 작은 별 장식 */}
        <g fill="#FFD700">
            <path d="M6 16 l1 2 2 1 -2 1 -1 2 -1-2 -2-1 2-1z" opacity="0.8" />
            <path d="M40 42 l0.8 1.5 1.5 0.8 -1.5 0.8 -0.8 1.5 -0.8-1.5 -1.5-0.8 1.5-0.8z" opacity="0.8" />
        </g>
    </svg>
);

const ConfettiDots: React.FC = () => (
    <div className={cls("treat-confetti")} aria-hidden="true">
        {[...Array(18)].map((_, i) => (
            <span key={i} className={cls(`confetti-dot c${i % 6}`)} style={{ left: `${(i * 5.5) % 100}%`, animationDelay: `${(i * 0.15) % 2}s` }} />
        ))}
    </div>
);

export const TreatCelebrationBanner: React.FC<Props> = ({ items, compact }) => {
    if (!items || items.length === 0) return null;
    const list = compact ? items.slice(0, 1) : items;

    return (
        <div className={cls("treat-banner-wrap")}>
            {list.map((it, idx) => (
                <div
                    key={idx}
                    className={cls("treat-banner")}
                    onClick={it.onClick}
                    role={it.onClick ? 'button' : undefined}
                >
                    <ConfettiDots />
                    <div className={cls("treat-banner-icon")}>
                        <FireworksIcon />
                    </div>
                    <div className={cls("treat-banner-body")}>
                        <div className={cls("treat-banner-title")}>
                            <IcParty size={16} /> <strong>{it.paidByNickname}</strong>님이 쏘셨어요!
                        </div>
                        <div className={cls("treat-banner-sub")}>
                            {it.meetingName ? `${it.meetingName}` : ''}
                            {it.round ? ` · ${it.round}차` : ''}
                            {it.storeName ? ` · ${it.storeName}` : ''}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
